import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { TENURE_REASONS, datePart, TODAY } from './tenure';

export function TenureFields({ value, onChange }) {
  const change = (key, next) => onChange({ ...value, [key]: next });
  return <fieldset className="space-y-3 rounded-lg border p-3">
    <legend className="px-1 text-sm font-semibold">Periodo e passaggio di titolarità</legend>
    <div>
      <Label htmlFor="tenure-mode">Stato della titolarità</Label>
      <select id="tenure-mode" className="w-full border rounded-md p-2 text-sm" value={value.tenure_mode} onChange={e => change('tenure_mode', e.target.value)}>
        <option value="OPEN">Ancora titolare — senza data di fine</option>
        <option value="CLOSED">Non più titolare / fine programmata</option>
      </select>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div><Label htmlFor="tenure-from">Titolare dal</Label>
        <Input id="tenure-from" type="date" value={value.valid_from} onChange={e => change('valid_from', e.target.value)} />
      </div>
      {value.tenure_mode === 'CLOSED' && <div><Label htmlFor="tenure-to">Titolare fino al {value.relationship_type !== 'EX_OWNER' ? '*' : '(se noto)'}</Label>
        <Input id="tenure-to" type="date" required={value.relationship_type !== 'EX_OWNER'} min={value.valid_from || undefined} value={value.valid_to} onChange={e => change('valid_to', e.target.value)} />
      </div>}
    </div>
    <p className="text-xs text-muted-foreground">La data di fine è l'ultimo giorno incluso. Con una fine futura la titolarità resta attiva fino a quel giorno. Se l'inizio non è noto, lascialo vuoto.</p>
    {value.relationship_type === 'EX_OWNER' && !value.valid_to && <p className="text-xs text-muted-foreground">Ex proprietario: la posizione resta storica anche se la data finale non è conosciuta. Non occorre inventarla per aggiornare la scheda.</p>}
    {datePart(value.valid_from) > TODAY() && <p className="text-xs text-amber-800">Titolarità futura: non sarà considerata attiva prima della data iniziale.</p>}
    {[['acquisition_reason', 'Motivo di acquisizione'], ...(value.tenure_mode === 'CLOSED' ? [['cessation_reason', 'Motivo di cessazione']] : [])].map(([key, label]) =>
      <div key={key}><Label htmlFor={key}>{label}</Label>
        <select id={key} className="w-full border rounded-md p-2 text-sm" value={value[key]} onChange={e => change(key, e.target.value)}>
          <option value="">Non specificato</option>
          {TENURE_REASONS.map(([code, name]) => <option key={code} value={code}>{name}</option>)}
        </select>
      </div>)}
    <p className="text-xs text-muted-foreground">Per un subentro conserva la posizione precedente con la sua data di fine e aggiungi un nuovo collegamento al nuovo titolare. Le quote registrate restano invariate.</p>
  </fieldset>;
}
